const settingsSiteNames = (names: string[]) => {
  if (names.length > 3) {
    return `${names?.slice(0, 2)?.join(', ')}, etc.`;
  }
  return names?.join(', ');
};

export default settingsSiteNames;
